import React from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function NotFound() {
    const navigate = useNavigate();
    return (
        <Container maxWidth="sm" sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Box textAlign="center" width="100%" py={8}>
                <Typography variant="h1" component="div" color="primary" fontWeight={700} gutterBottom sx={{ fontSize: { xs: '4rem', sm: '6rem' } }}>
                    404
                </Typography>
                <Typography variant="h5" color="text.secondary" gutterBottom>
                    Oops! The page you are looking for does not exist.
                </Typography>
                <Typography variant="body1" color="text.secondary" mb={4}>
                    The page might have been removed, had its name changed, or is temporarily unavailable.
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={() => navigate('/')}
                    sx={{ borderRadius: 8, px: 4, py: 1.5, fontWeight: 600, fontSize: '1.1rem', boxShadow: 3 }}
                >
                    Go to Home
                </Button>
            </Box>
        </Container>
    );
}

export default NotFound